export const PRANIC_SLUG = 'pranic-healing';
export const PRANIC_PATH = '/services/pranic-healing';
export const CONSULTATION_LABEL = 'Consultation Required — Pricing Shared During Consultation';

export const PRANIC_HERO_IMAGE =
  'https://images.unsplash.com/photo-1532798442725-41036acc7489?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600';
export const PRANIC_CARD_IMAGE =
  'https://images.pexels.com/photos/7113430/pexels-photo-7113430.jpeg?auto=compress&cs=tinysrgb&w=1200';

export const PRANIC_INTRO = {
  eyebrow: 'Specialist Service · Complementary Practice',
  title: 'Pranic Healing',
  lead:
    'A calm, no-touch energy practice offered as a complementary addition to your ZEEVA journey — an intentional space for rest, balance and a renewed sense of wellbeing.',
};

export const PRANIC_OVERVIEW = {
  heading: 'A quiet counterpart to capability',
  paragraphs: [
    'Pranic Healing is a traditional, no-touch practice rooted in the idea of prana — the Sanskrit word for life energy. Sessions are calm, unhurried and take place while you rest comfortably, fully clothed.',
    'At ZEEVA, strength, mobility and recovery are built through evidence-based training. Pranic Healing sits alongside that work as an optional, complementary practice for those who value stillness and intentional rest as part of a balanced life.',
  ],
};

export const PRANIC_STEPS = [
  { title: 'Enquire', text: 'Share a little about yourself and what draws you to the practice using the form below.' },
  { title: 'Consult', text: 'A private conversation to understand your intentions, answer questions, and share session format and pricing.' },
  { title: 'Session', text: 'A quiet, no-touch session — in person or online — while you rest comfortably and fully clothed.' },
  { title: 'Reflect', text: 'Time to reflect on the experience and how it may sit alongside your wider ZEEVA routine.' },
];

export const PRANIC_AUDIENCE = [
  'Those seeking a calm, restorative practice within a demanding schedule',
  'ZEEVA members who want a complementary mind–body element alongside training',
  'Anyone who values intentional rest as part of a balanced, capable life',
  'Individuals curious about traditional energy practices in a respectful, non-clinical setting',
];

export const PRANIC_DISCLAIMER =
  'Pranic Healing is offered as a complementary wellbeing practice. It is not a medical treatment, does not diagnose, treat, cure or prevent any condition, and is not a substitute for advice, diagnosis or treatment from a qualified healthcare professional. Please continue any care or medication prescribed by your doctor.';

export const MODE_OPTIONS = [
  { value: 'in-person', label: 'In-person' },
  { value: 'online', label: 'Online' },
];

export const AREA_OPTIONS = [
  { value: 'relaxation-calm', label: 'Relaxation & Calm' },
  { value: 'emotional-balance', label: 'Emotional Balance' },
  { value: 'energy-vitality', label: 'Energy & Vitality' },
  { value: 'complement-zeeva-program', label: 'Complement to my ZEEVA Program' },
  { value: 'general-wellbeing', label: 'General Wellbeing' },
  { value: 'other', label: 'Other' },
];

export const CONSENT_TEXT =
  'I understand Pranic Healing is a complementary wellbeing practice and not a substitute for medical care, and I agree to be contacted by ZEEVA Life about this enquiry.';

export const SLOT_OPTIONS = [
  { value: 'morning', label: 'Morning · 9am–12pm' },
  { value: 'afternoon', label: 'Afternoon · 12–4pm' },
  { value: 'evening', label: 'Evening · 4–8pm' },
];

export const BOOKING_WINDOW_DAYS = 30;

export const detectTimeZone = () => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || 'Asia/Kolkata';
  } catch {
    return 'Asia/Kolkata';
  }
};

const toISODate = (d) =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

export const getBookableDates = (now = new Date()) => {
  const dates = [];
  for (let i = 1; i <= BOOKING_WINDOW_DAYS; i += 1) {
    const d = new Date(now.getFullYear(), now.getMonth(), now.getDate() + i);
    if (d.getDay() !== 0) {
      dates.push({
        value: toISODate(d),
        weekday: d.toLocaleDateString('en-GB', { weekday: 'short' }),
        day: d.getDate(),
        month: d.toLocaleDateString('en-GB', { month: 'short' }),
      });
    }
  }
  return dates;
};
